export default __webpack_public_path__ + "locales/de/FormFillingTipsDialog.json?hash=306b2ba8ec339ceca3bbab2d60ba8756";